import React, { useEffect } from 'react';
import SupportChatWidget from './components/SupportChatWidget';

/**
 * Página /embed/sofia — usada como <iframe src> pela landing
 * `promo.consultamais.org`. Renderiza o SupportChatWidget em modo tela cheia,
 * sem chrome do PatientLayout. As chamadas para /support/chat continuam saindo
 * do próprio domínio consultamais.app (mesma origem), então CORS/App Check
 * seguem aplicáveis normalmente.
 */
export default function EmbedSofia() {
  useEffect(() => {
    const prevBodyBg = document.body.style.background;
    const prevBodyMargin = document.body.style.margin;
    const prevHtmlHeight = document.documentElement.style.height;
    const prevBodyHeight = document.body.style.height;
    document.body.style.margin = '0';
    document.body.style.background = '#fff';
    document.documentElement.style.height = '100%';
    document.body.style.height = '100%';
    return () => {
      document.body.style.background = prevBodyBg;
      document.body.style.margin = prevBodyMargin;
      document.documentElement.style.height = prevHtmlHeight;
      document.body.style.height = prevBodyHeight;
    };
  }, []);

  return <SupportChatWidget embedded defaultOpen />;
}
